var path = '/pages/settings/views/index.tpl.html';
var html = "settings index\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings/views/index.tpl.html
// module id = 2316
// module chunks = 1